// extracted by mini-css-extract-plugin
export default {"dropdown":"E0v0YQCJu5tpGB_JIwvg"};